<script setup lang="ts">
import { computed } from 'vue';

interface Item {
  name: string;
  percent: string;
  img: string;
  enabled?: boolean;
  url?: string;
}

const props = defineProps<{
  item: Item;
  blueGradient?: string;
  orangeGradient?: string;
}>();

const emit = defineEmits<{
  (e: 'select', url: string): void;
}>();

const blueGradient =
  props.blueGradient ??
  'radial-gradient(168.3% 138% at 36.76% -16.67%, #1515E5 0%, #000098 100%)';

const orangeGradient =
  props.orangeGradient ??
  'radial-gradient(168.3% 138% at 36.76% -16.67%, #FF704A 0%, #FF3400 100%)';

const isEnabled = computed(() => props.item.enabled !== false);

const handleClick = () => {
  emit('select', props.item.url || '/promotions/cashback-diario-ativo');
};

const baseClass =
  'flex items-center justify-between rounded-[12px] p-1 relative h-[52px] transform transition duration-150 ease-in-out';

const rootClass = computed(() => {
  if (isEnabled.value) {
    return 'cursor-pointer hover:scale-105 hover:shadow-lg hover:brightness-110 active:scale-95 focus:outline-none';
  }

  return 'cursor-pointer hover:scale-105 hover:shadow-lg active:scale-95 focus:outline-none grayscale opacity-60';
});
</script>

<template>
  <div class="w-full">
    <div
      :aria-disabled="!isEnabled"
      :class="[baseClass, rootClass]"
      :style="{
        background: blueGradient,
        boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.03)',
      }"
      @click="handleClick"
    >
      <div class="flex items-center gap-2">
        <div
          class="w-14 h-14 rounded-full bg-transparent flex items-center justify-center overflow-hidden"
        >
          <NuxtImg
            alt=""
            class="w-full h-full object-contain"
            :draggable="false"
            :src="getAssetsUrlForCDN(props.item.img)"
          />
        </div>
        <div class="flex flex-col">
          <span class="text-[#00ddff] text-[10px] font-semibold leading-[12px]"
            >Cashback</span
          >
          <span class="text-white text-[15px] font-bold">{{
            props.item.name
          }}</span>
        </div>
      </div>

      <div
        class="absolute right-0 top-1/2 transform -translate-y-1/2 flex items-center"
      >
        <div
          class="flex-none inline-flex w-[92px] h-[52px] gap-2 items-center justify-center px-4 py-2 rounded-[10px]"
          :style="{
            background: orangeGradient,
            color: '#FFF',
            fontSize: '19.671px',
            fontStyle: 'italic',
            fontWeight: 900,
            lineHeight: '17.751px',
          }"
        >
          {{ props.item.percent }}
          <NuxtIcon
            alt="arrow"
            class="w-5 h-5"
            :draggable="false"
            name="menu-lateral/arrow"
          />
        </div>
      </div>
    </div>
  </div>
</template>
